import { withSearch } from "@elastic/react-search-ui";

function ClearFilters({ filters, clearFilters, removeFilter }) {
  return (
    <div className="flex item-center justify-start gap-x-2 flex-wrap sm:px-4 text-lm-darkBlue">
      {filters.map(filter => (  
          filter.values.map(
            filterNames => (
              <button className="flex items-center gap-2 p-2 my-2 bg-gray-100 border border-gray-300 rounded" key={typeof filterNames === 'object' ? filterNames.name : filterNames} onClick={() => removeFilter((filter.field), (filterNames))} >
                <i className="icon-times text-red-500"></i>
                {typeof filterNames === 'object' ? filterNames.name : filterNames}
              </button>
            )
          )
        ))}  
      {filters.length > 0 &&
        <button className="p-2 my-2 bg-lm-lightBlue text-white rounded" onClick={() => clearFilters()}>
         Clear filters
        </button>
      }
    </div>
  );
}

export default withSearch(({ filters, clearFilters, removeFilter}) => ({
  filters,
  clearFilters,
  removeFilter 
}))(ClearFilters);